export const cardGlobalStyles = `
/* Import Font and Material Design Icons */
@import url('https://assets.speach.me/jsdelivr/npm/@mdi/font@7.2.96/css/materialdesignicons.min.css');
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,400;0,600;0,700;0,900;1,400;1,600;1,700;1,900&display=swap');

:root {
  /* Header/Footer */
  --flipcard-header-bg: #E8E3F3;
  --flipcard-footer-bg: #E8E3F3;

  /* Corps de carte */
  --flipcard-body-bg: #FFFFFF;
  --flipcard-border-color: #E0E0E0;
  --flipcard-border-radius: 12px;
  --flipcard-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  /* Texte */
  --flipcard-text-color: #1A1A1A;

  /* Icônes et boutons */
  --flipcard-icon-color: #1A1A1A;
  --flipcard-icon-hover-color: rgba(0, 0, 0, 0.05);
  --flipcard-drag-handle-color: #9E9E9E;

  /* Options "Add text" / "Add image" */
  --flipcard-border-color: #E8E3F3;
  --flipcard-option-border-radius: 12px;
  --flipcard-option-icon-color: #9B9BDF;
  --flipcard-text-color: #1A1A1A;
  --flipcard-option-hover-bg: #F5F3FA;

  /* Séparateur "or" */
  --flipcard-separator-color: #B8B8E0;
}

/* Container principal */
.flipcard-container {
  width: 320px;
  height: 416px;
  border-radius: var(--flipcard-border-radius);
  border: 1px solid var(--flipcard-border-color);
  background: var(--flipcard-header-bg);
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  overflow: hidden;
  user-select: none;
  font-family: 'Nunito Sans', sans-serif;
  color: var(--flipcard-text-color);
  margin: 8px;
}

/* Header (mode édition uniquement) */
.flipcard-header {
  height: 48px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  background: var(--flipcard-header-bg);
  border-radius: var(--flipcard-border-radius) var(--flipcard-border-radius) 0 0;
}

.flipcard-drag-handle {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
}

.flipcard-drag-handle:active {
  cursor: grabbing;
}

.flipcard-drag-handle i {
  font-size: 20px;
  color: var(--flipcard-drag-handle-color);
}

.flipcard-title {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: var(--flipcard-text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.flipcard-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.flipcard-actions .action-button {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  padding: 0;
}

.flipcard-actions .action-button:hover {
  color: var(--flipcard-icon-hover-color);
}

.flipcard-actions .action-button i {
  font-size: 20px;
  color: var(--flipcard-icon-color);
}

.flipcard-actions .action-button i:hover {
  color: var(--flipcard-icon-hover-color);
}

.flipcard-btn-reset {
  display: none;
}

.flipcard-btn-reset.visible {
  display: flex;
}

/* Corps de carte */
.flipcard-inner {
  height: 320px;
  position: relative;
  background: var(--flipcard-body-bg);
  overflow: hidden;
  border-radius: 12px;
}

.flipcard-face {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  padding: 32px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
}

.flipcard-face.active {
  display: flex;
  flex-direction: column;
}

/* Options "Add text" et "Add image" */
.flipcard-content-options {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  position: relative;
}

.flipcard-content-options.hidden {
  display: none;
}

.flipcard-option-text,
.flipcard-option-image {
  width: 100%;
  max-width: 280px;
  height: 110px;
  border: 1px solid var(--flipcard-border-color);
  border-radius: var(--flipcard-option-border-radius);
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  box-sizing: border-box;
}

.flipcard-option-text:hover,
.flipcard-option-image:hover {
  background: var(--flipcard-option-hover-bg);
  border-color: #D0D0E8;
}

.flipcard-option-text i,
.flipcard-option-image i {
  font-size: 40px;
  color: var(--flipcard-option-icon-color);
  height: 40px;
  display: flex;
  align-items: center;
}

.flipcard-option-text span,
.flipcard-option-image span {
  font-size: 16px;
  font-weight: 600;
  color: var(--flipcard-text-color);
}

/* Séparateur "or" */
.flipcard-separator {
  font-size: 14px;
  font-weight: 600;
  color: var(--flipcard-separator-color);
  margin: -4px 0;
  text-align: center;
}

/* Zone de contenu (texte ou image) */
.flipcard-content {
  width: 100%;
  height: 100%;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
}

.flipcard-content.has-content {
  display: flex;
}

.flipcard-content textarea,
.flipcard-content [contenteditable="true"] {
  width: 100%;
  border: none;
  outline: none !important;
  font-size: 16px;
  font-weight: 600;
  color: var(--flipcard-text-color);
  resize: none;
  background: transparent;
  text-align: center;
  font-family: 'Nunito Sans', sans-serif;
  line-height: 1.4;
  box-sizing: border-box;
  max-height: 100%;
  cursor: text;
}

.flipcard-content textarea::placeholder {
  color: #B8B8E0;
  opacity: 0.7;
}

.flipcard-content img {
  max-height: 250px;
  max-width: 250px;
  object-fit: contain;
}

.flipcard-text-content:not(.has-text)::before {
  content: attr(data-placeholder);
  color: #999;
  font-style: italic;
  opacity: 0.6;
}

.flipcard-text-content:focus::before {
  opacity: 0.4;
}

/* Footer */
.flipcard-footer {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--flipcard-footer-bg);
  border-radius: 0 0 var(--flipcard-border-radius) var(--flipcard-border-radius);
}

.flipcard-btn-flip {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  font-size: 16px;
  font-weight: 600;
  color: var(--flipcard-text-color);
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: background 0.2s ease;
  font-family: 'Nunito Sans', sans-serif;
}

.flipcard-btn-flip:hover, .flipcard-btn-flip:hover i {
  color: var(--flipcard-icon-hover-color);
}

.flipcard-btn-flip i {
  font-size: 20px;
  color: var(--flipcard-icon-color);
}

/* Drag and drop states */
.flipcard-container.dragging {
  opacity: 0.5;
  cursor: grabbing;
}

.flipcard-container.drag-over {
  border-color: var(--flipcard-option-icon-color);
  box-shadow: 0 4px 20px rgba(91, 95, 237, 0.2);
}

/* Responsive adjustments for smaller screens */
@media (max-width: 360px) {
  .flipcard-container {
    width: 100%;
    max-width: 320px;
  }
}
`;
